import { NAV_MENU_TYPE } from '../../types';

interface HistoryRouterData {
    router: string;
    module: NAV_MENU_TYPE;
}

/**
 * @param historyRowData 历史记录类型
 * @param detailId 历史记录ID
 * @returns 历史记录数据，用于同一模块内使用vue-router跳转的路由数据
 */
export const getHistoryRouterData = (historyRowData: NAV_MENU_TYPE, detailId: string): HistoryRouterData => {
    switch (historyRowData) {
    case NAV_MENU_TYPE.SEEK_SEARCH:
        return {
            router: `/page/${detailId}`,
            module: NAV_MENU_TYPE.HOME,
        };
    case NAV_MENU_TYPE.TECH_MIND:
    case NAV_MENU_TYPE.MATERIAL_MIND:
    case NAV_MENU_TYPE.IDEA_EXPLORATION:
        return {
            router: `/board/${detailId}`,
            module: NAV_MENU_TYPE.TECH_MIND,
        };
    case NAV_MENU_TYPE.TECH_RESEARCH:
        return {
            router: `/report/${detailId}`,
            module: NAV_MENU_TYPE.TECH_RESEARCH,
        };
    case NAV_MENU_TYPE.TECH_FMEA:
        return {
            router: `/page/${detailId}`,
            module: NAV_MENU_TYPE.TECH_FMEA,
        };
    case NAV_MENU_TYPE.PATENT_DISCLOSURE:
        return {
            router: `/disclosure/${detailId}`,
            module: NAV_MENU_TYPE.PATENT_DISCLOSURE,
        };
    case NAV_MENU_TYPE.AI_GENERATE:
        return {
            router: `/ai/agent-flow/${detailId}`,
            module: NAV_MENU_TYPE.AI_GENERATE,
        };
    case NAV_MENU_TYPE.WORK_PROJECT:
        return {
            router: `/graph/${detailId}`,
            module: NAV_MENU_TYPE.WORK_PROJECT,
        };
    case NAV_MENU_TYPE.LS_DOCUMENT_QA:
        return {
            router: `/ai-ls/document-agent/${detailId}`,
            module: NAV_MENU_TYPE.LS_CHAT,
        };
    case NAV_MENU_TYPE.LS_CHAT:
        return {
            router: `/ai-ls/chat-agent/${detailId}`,
            module: NAV_MENU_TYPE.LS_CHAT,
        };
    case NAV_MENU_TYPE.LS_MARKUSH_PATENT_DRAFT:
        return {
            router: `/ai-ls/markush-draft-agent/${detailId}`,
            module: NAV_MENU_TYPE.LS_CHAT,
        };
    default:
        return {
            router: '',
            module: NAV_MENU_TYPE.HOME,
        };
    }
}
